/**
 * Testimonial Slider Component
 *
 * Initializes Swiper sliders for testimonials with centered slides,
 * auto-sizing, navigation, and custom styling.
 *
 * @requires swiper (loaded via CDN in layout)
 */

/**
 * Initialize all testimonial sliders on the page
 */
export function initTestimonialSlider() {
  const testimonialSliders = document.querySelectorAll(
    "[data-testimonial-slider]",
  );

  if (!testimonialSliders.length) return;

  testimonialSliders.forEach((sliderContainer) => {
    const swiperWrap = sliderContainer.querySelector(
      "[data-testimonial-swiper]",
    );
    if (!swiperWrap) return;

    const prevButton = sliderContainer.querySelector("[data-testimonial-prev]");
    const nextButton = sliderContainer.querySelector("[data-testimonial-next]");
    const logoButtons = sliderContainer.querySelectorAll(
      "[data-testimonial-logo-btn]",
    );

    // Check if Swiper is available
    if (typeof Swiper === "undefined") {
      console.warn("Swiper is not loaded. Please include the Swiper library.");
      return;
    }

    // Initialize Swiper
    const swiper = new Swiper(swiperWrap, {
      slidesPerView: "auto",
      spaceBetween: 20,
      centeredSlides: true,
      // centeredSlidesBounds: true,
      loop: false,
      initialSlide: 0,
      speed: 600,
      grabCursor: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      on: {
        init: function () {
          // Set initial active state after swiper is fully initialized
          // console.log(
          //   "Init - realIndex:",
          //   this.realIndex,
          //   "activeIndex:",
          //   this.activeIndex,
          // );
          updateActiveLogoBorder(logoButtons, this.realIndex);
        },
        slideChangeTransitionEnd: function () {
          // Use slideChangeTransitionEnd instead of slideChange to avoid multiple updates
          // console.log(
          //   "Slide change complete - realIndex:",
          //   this.realIndex,
          //   "activeIndex:",
          //   this.activeIndex,
          // );
          updateActiveLogoBorder(logoButtons, this.realIndex);
        },
      },
    });

    // Handle logo button clicks
    logoButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const slideIndex = parseInt(button.getAttribute("data-slide-index"));
        // console.log(
        //   "Clicking logo for slide index:",
        //   slideIndex,
        //   "Current realIndex:",
        //   swiper.realIndex,
        // );
        // Use slideToLoop for proper loop mode navigation
        swiper.slideToLoop(slideIndex, 600);
      });
    });

    // Store swiper instance for potential external access
    swiperWrap._swiperInstance = swiper;
  });
}

/**
 * Update active logo button border styling
 */
function updateActiveLogoBorder(logoButtons, activeIndex) {
  console.log("Updating active logo for index:", activeIndex);
  logoButtons.forEach((button, index) => {
    const slideIndex = parseInt(button.getAttribute("data-slide-index"));
    const img = button.querySelector("img");

    if (slideIndex === activeIndex) {
      // Active state
      button.classList.remove("border-black-600");
      button.classList.add("border-white");
      if (img) {
        img.classList.remove("opacity-60");
        img.classList.add("opacity-100");
      }
    } else {
      // Inactive state
      button.classList.remove("border-white");
      button.classList.add("border-black-600");
      if (img) {
        img.classList.remove("opacity-100");
        img.classList.add("opacity-60");
      }
    }
  });
}

/**
 * Destroy all testimonial slider instances
 * Useful for cleanup or re-initialization
 */
export function destroyTestimonialSlider() {
  const testimonialSliders = document.querySelectorAll(
    "[data-testimonial-slider]",
  );

  testimonialSliders.forEach((sliderContainer) => {
    const swiperWrap = sliderContainer.querySelector(
      "[data-testimonial-swiper]",
    );
    if (swiperWrap?._swiperInstance) {
      swiperWrap._swiperInstance.destroy(true, true);
      delete swiperWrap._swiperInstance;
    }
  });
}

// Auto-initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTestimonialSlider);
} else {
  initTestimonialSlider();
}
